export default __webpack_public_path__ + "static/media/cc-large.4bd81702.png";